<div role="field" class="{{ base }}_field">
  <div role="left" class="{{ base }}_arrow {{ base }}_arrow--left"></div>
  <div role="bar" class="{{ base }}_bar"></div>
  <div role="right" class="{{ base }}_arrow {{ base }}_arrow--right"></div>
  <div class="{{ base }}_substrate"></div>
</div>
